

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import store from '../store/index.js';
import {reduce} from 'lodash';
import {isAutohomeApp} from '../../../../common/util';
export default {
    data(){
        return {
            list: [
                {
                    title: '点赞中国好山河',
                    tag: 'jiang',
                    desc: '细数美景令人心醉',
                    webUrl: '//follow.m.autohome.com.cn/topic?tid=25813&type=0&from=singlemessage&isappinstalled=0',
                    appUrl: 'autohome://rninsidebrowser?url=rn%3a%2f%2fFollow_Find%2fTopicList%3fname%3d%25E7%2582%25B9%25E8%25B5%259E%25E4%25B8%25AD%25E5%259B%25BD%25E5%25A5%25BD%25E5%25B1%25B1%25E6%25B2%25B3'
                },
                {
                    title: '红旗H9',
                    tag: 'xin',
                    desc: '气场全开超霸气',
                    webUrl: '//follow.m.autohome.com.cn/topic?tid=20334&type=0&from=singlemessage&isappinstalled=0',
                    appUrl: 'autohome://rninsidebrowser?url=rn%3a%2f%2fFollow_Find%2fTopicList%3fname%3d%25E7%25BA%25A2%25E6%2597%2597H9'
                },
                {
                    title: '红旗H5',
                    tag: 'jian',
                    desc: '越级体验就选TA',
                    webUrl: '//follow.m.autohome.com.cn/topic?tid=739&type=0&from=singlemessage&isappinstalled=0',
                    appUrl: 'autohome://rninsidebrowser?url=rn%3a%2f%2fFollow_Find%2fTopicList%3fname%3d%25E7%25BA%25A2%25E6%2597%2597H5'
                },
                {
                    title: '红旗HS5',
                    tag: 'hot',
                    desc: '女生眼中的男神车',
                    webUrl: '//follow.m.autohome.com.cn/topic?tid=9498&type=0&from=singlemessage&isappinstalled=0',
                    appUrl: 'autohome://rninsidebrowser?url=rn%3a%2f%2fFollow_Find%2fTopicList%3fname%3d%25E7%25BA%25A2%25E6%2597%2597HS5'
                },
                {
                    title: '红旗HS7',
                    tag: 'hot',
                    desc: '性价比之选快围观',
                    webUrl: '//follow.m.autohome.com.cn/topic?tid=25813&type=0&from=singlemessage&isappinstalled=0',
                    appUrl: 'autohome://rninsidebrowser?url=rn%3a%2f%2fFollow_Find%2fTopicList%3fname%3d%25E7%25BA%25A2%25E6%2597%2597HS7'
                },
                {
                    title: '红旗E115',
                    tag: 'xin',
                    desc: '超炫！这是国产库里南？',
                    webUrl: '//follow.m.autohome.com.cn/topic?tid=15470&type=0&from=singlemessage&isappinstalled=0',
                    appUrl: 'autohome://rninsidebrowser?url=rn%3a%2f%2fFollow_Find%2fTopicList%3fname%3d%25E7%25BA%25A2%25E6%2597%2597E115'
                }
            ]
        }
    },
    components: {
	    swiper,
	    swiperSlide
    },
    mounted() {
        this.$nextTick(() => {
            this.addMointor();
        })
    },
    methods: {
        getTit(title) {
            if(title.length > 7) {
                return title.substring(0,7) + '...';
            } else {
                return title;
            }
        },
        getDesc(desc) {
            if(desc.length > 10) {
                return desc.substring(0, 10) + '...';
            } else {
                return desc;
            }
        },
        jump(data) {
            if (isAutohomeApp()) {
                window.open(data.appUrl);
            } else {
                window.open(data.webUrl);
            }
        },
        addMointor() {
            // 曝光
            this.$clickMonitor.update(reduce(document.querySelectorAll('.j-hotTopic'), (arr, el) => {
				const callback = function (params) {
					const buttonId = `hotTopic-${params.monitor.status}`;
					return {
						buttonId,
						...store.getClickMonitorParams()
					};
				};
				arr.push({el, event: 'expose', callback});
				return arr;
            }, []));
            
            // 点击
			this.$clickMonitor.update(reduce(document.querySelectorAll('.j-hotTopic-item'), (arr, el) => {
				const callback = function (params) {
					const index = params.options.el.getAttribute('data-index');
					const buttonId = `hotTopic-${+index + 1}-${params.monitor.status}`;
					return {
						buttonId,
						...store.getClickMonitorParams()
					};
				};
				arr.push({el, event: 'click', callback});
				return arr;
            }, []));
            
		}
    }
}
</script>
<template>
  <div class="wrap">
      <h3 class="title">热门话题</h3>
      <div class="main j-hotTopic">
        <div class="item j-hotTopic-item" v-for="(item, index) in list" :key="item.title" @click="jump(item)" :data-index="index">
            <p class="topic-title">
                <i class="num">0{{index+1}}</i>
                <span>{{getTit(item.title)}}</span>
                <i class="tag" :class="item.tag"></i></p>
            <p class="desc">{{ getDesc(item.desc)}}</p>
        </div>
      </div>
  </div>
</template>
<style lang="stylus" scoped>
    .wrap
        margin-bottom 1rem
        .title
            margin 0.5rem auto
            position relative
            width 6.72rem
            text-indent 2.05rem
            &:before
                content ''
                position absolute
                left 0.67rem
                top .2rem
                width 1.28rem
                height 1.23rem
                background url("../../assets/title_hot_bg.svg") no-repeat
                background-size 100%
            &:after
                content ''
                display inline-block
                position absolute
                left 0
                bottom 0
                width 100%
                height 0.11rem
                background url("../../assets/title_line.png") top left no-repeat
                background-size 100%
        .main
            background #ffffff
            margin 0 auto
            width 17.33rem
            height 10rem
            padding 1.2rem 0.59rem
            display flex
            flex-wrap wrap
            justify-content space-between
            box-sizing border-box
            border-radius 0.27rem
            .item
                width 50%
                margin-bottom 1.28rem
                .topic-title
                    position relative
                    font-size 0.75rem
                    color rgba(17,30,54,1)
                    line-height 0.75rem
                    font-weight 500
                    font-family PingFangSC-Medium
                    .num
                        position absolute
                        left 0
                        display inline-block
                        width 0.91rem
                        height 0.91rem
                        background rgba(255,232,232,1)
                        font-size 0.53rem
                        border-radius 100%
                        font-style normal
                        text-align center
                        line-height 0.91rem
                        margin-right 0.09rem
                        color #9A1810
                    span 
                        padding-left 1rem
                    .tag
                        display inline-block
                        width 0.96rem
                        height 0.96rem
                        position absolute
                        bottom 0
                        margin-left .1rem
                    .hot
                        background url("../../assets/tag_hot.png") no-repeat
                        background-size 100%
                    .jian
                        background url("../../assets/tag_jian.png") no-repeat
                        background-size 100%
                    .jiang
                        background url("../../assets/tag_jiang.png") no-repeat
                        background-size 100%
                    .xin
                        background url("../../assets/tag_xin.png") no-repeat
                        background-size 100%
                .desc
                    margin-top 0.15rem
                    padding-left 1rem
                    font-size: 0.64rem
                    font-family PingFangSC-Light,PingFang SC
                    color rgba(102,109,127,1)
</style>